import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderPrayPeace from "../../../../src/content/prayforpeace/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderPrayPeace,
  React
};